// 加载插件
const requirePlugin = require.context('./', true, /\.js$/)
requirePlugin.keys().forEach((fileName) => {
  requirePlugin(fileName)
})
